export default __webpack_public_path__ + "static/media/Sebastian_Madrigal_Photographer.eaa72a22.webp";